import {
  Ban,
  Copy,
  ExternalLink,
  FileText,
  Mail,
  Menu,
  Target,
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { TargetareUniversRand } from "@/types/targetare";

type MeniuRandProps = {
  rand: TargetareUniversRand;
  onFisa: (cui: string) => void;
  onExclude: (cui: string) => void;
  onCopiaza: (text: string) => void;
  onTinta?: (cui: string) => void;
};

export function MeniuRand({
  rand,
  onFisa,
  onExclude,
  onCopiaza,
  onTinta,
}: MeniuRandProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="rounded p-1 text-muted-foreground hover:bg-muted hover:text-foreground"
          aria-label={`Acțiuni pentru ${rand.denumire}`}
          onClick={(e) => e.stopPropagation()}
        >
          <Menu className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem onClick={() => onFisa(rand.cui)}>
          <FileText className="mr-2 h-4 w-4" />
          Fișa firmei
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onCopiaza(rand.cui)}>
          <Copy className="mr-2 h-4 w-4" />
          Copiază CUI
        </DropdownMenuItem>
        {rand.email_principal && (
          <DropdownMenuItem
            onClick={() => onCopiaza(rand.email_principal ?? "")}
          >
            <Mail className="mr-2 h-4 w-4" />
            Copiază emailul
          </DropdownMenuItem>
        )}
        {rand.site && (
          <DropdownMenuItem asChild>
            <a href={`https://${rand.site}`} target="_blank" rel="noreferrer">
              <ExternalLink className="mr-2 h-4 w-4" />
              Deschide site-ul
            </a>
          </DropdownMenuItem>
        )}
        {onTinta && (
          <DropdownMenuItem onClick={() => onTinta(rand.cui)}>
            <Target className="mr-2 h-4 w-4" />
            Adaugă la ținte
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="text-destructive"
          onClick={() => onExclude(rand.cui)}
        >
          <Ban className="mr-2 h-4 w-4" />
          Exclude firma din campanii
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
